import {getUpdateAsset} from '../reducers/state';
import {makeEditAssetModal} from './configEditAssetRequests';
import {UPDATE_ASSET_PREFIX} from './state';


export const {
  /** @type {ReduxRequestModal} */
  requestModal: updateAssetRequestModal,
} = makeEditAssetModal({
  isCreate: false,
  prefix: UPDATE_ASSET_PREFIX,
  getState: getUpdateAsset,
});



// WEBPACK FOOTER //
// ./src/js/assets/redux/updateAsset.js